import { render, staticRenderFns } from "./DialogCreateAssociate.vue?vue&type=template&id=8d35af6c&scoped=true&"
import script from "./DialogCreateAssociate.vue?vue&type=script&lang=ts&"
export * from "./DialogCreateAssociate.vue?vue&type=script&lang=ts&"
import style0 from "./DialogCreateAssociate.vue?vue&type=style&index=0&id=8d35af6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d35af6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VImg,VRow,VSelect,VTextField})
